import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks/hooks';
import { deepCopy } from '../../../../../../common/services/common.service';
import PageLoader from '../../../../../../components/PageLoader';
import Popup from '../../../../../../common/components/popup';
import { selectCommunitiesQueryItems } from '../../../../../../redux/community/selector';
import { communities } from '../../../../../../redux/community/action';
import ModalForumGroupsComponent from '../components/forum-groups-modal.component';
import CommunityComponent from '../components/community.component';
import { selectListItems } from '../../../../../../redux/library/selector';
import { settings } from '../../../../../../redux/settings/actions';
import UploadFiles from '../../../../../../models/UploadFile';
import { selectCurrent } from '../../../../../../redux/settings/selectors';


const Community = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [columnDefs, setColumnDefs] = useState({});
  const [selectedForumGroups, setSelectedForumGroups] = useState<any>([])
  const [addItem, setAddItem] = useState<any>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const libraryData = useSelector(selectListItems)
  const { getUploadFiles } = useAppSelector(selectCurrent)
   const [openConfirmationLogoFile, setOpenConfirmationLogoFile] = React.useState(false);
   const [openConfirmationCoverFile, setOpenConfirmationCoverFile] = React.useState(false); 
  const queryItems = useSelector(selectCommunitiesQueryItems)
  const [selectedForumGroupsValues, setSelectedForumGroupsValues] = useState([]);
  const [openImageFile, setOpenImageFile] = useState<any>([]);
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedCommunity,
    setSelectedCommunity
  ] = useState<any>([])

   const handleClose = () => {
      if (openConfirmationLogoFile) {
        setOpenConfirmationLogoFile(false)
    }else if(openConfirmationCoverFile){
      setOpenConfirmationCoverFile(false)
    }
        dispatch(settings.set({ getUploadFiles: 'close' }))
        
      }

  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])


  const fetchQueryById = () => {
    dispatch(communities.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/community/communities/query`, entity: 'communities', jsonData: {

        Records: [
          {
            "Id": parmas?.id

          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })




  }
  

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setSelectedCommunity({ ...selectedCommunity, [field]: event })
    setSelectedForumGroups({ ...selectedForumGroups, [field]: event })
  }

  // media handle form change
  const handleFormMediaItemChange: any = ({ value }: any) => {
    setMediaFiles(value);
  }

  useEffect(
    () => {
      createColumnDefs()



      if (parmas?.id > 0) {
        fetchQueryById()

      } else {
        setIsLoading(false)
      }

    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        const querydata: any = queryItems?.result?.items
        setSelectedCommunity(querydata)

        const forumGroupsItemsData: any = queryItems?.result?.items?.ForumGroups?.map((item: any) => {
          const itemData = {
            Id: item?.Id,
            Name: item?.Name,
            Description: item?.Description,
            DisplayOrder: item?.DisplayOrder,



          }
          return itemData
        })
        console.log(forumGroupsItemsData, 'oneProgramItemsData')
        setSelectedForumGroupsValues(forumGroupsItemsData)

      }
    },
    [isQuery]
  )



  const back = () => {
    navigate('/management/e-appilcations/community/communities')
  }



  //Save the modal data function
  const handleSaveItem = async (data: any) => {

    // Collect new form data

    const newItem = {
      Id: data?.Id || Date.now(),
      Name: data?.Name,
      Description: data?.Description,
      DisplayOrder: data?.DisplayOrder,
    }

    //Update the new data
    setSelectedForumGroupsValues((prevState: any) => {
      // Check if the item exists by ID
      const exists = prevState.some((item: any) => item.Id === newItem.Id);
      // If it exists, update it, otherwise add the new item
      return exists
        ? prevState.map((item: any) => item.Id === newItem.Id ? newItem : item)
        : [...prevState, newItem];
    });
    closeModal();
  }

  // Add button
  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Forum Groups</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAddItem(),
    }
  ];

  //Table ColumnDef Function
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Name' },
      { field: 'Description', headerName: 'Description' },
      { field: 'DisplayOrder', headerName: 'DisplayOrder', },


    ]);
  }

  //Add the data in the Table Function
  const handleAddItem = () => {
    setAddItem({
      id: 0
    });
  }

  //Table Edit Function
  const handleEdit = (itemData: any) => {
    setAddItem({
      id: itemData.id
    })
    setSelectedForumGroups(itemData)

  }

  //Table Delete Function
  const handleDelete = (data: any) => {
    setSelectedForumGroupsValues((prevState: any) =>
      prevState.filter((item: any) => item?.Id !== data?.Id)
    );

  };

  //Modal Close Function
  const closeModal = () => {
    setAddItem(undefined)
    setSelectedForumGroups('')
  }

  // Modal Function
  const NewItemPopup = ({ handleSaveItem }: any) => {
    const [localItems, setLocalItems] = useState(deepCopy(selectedForumGroups));
    const handleLocalFormChange = (value: any, field: any) => {
      setLocalItems((prev: any) => ({
        ...prev,
        [field]: value,
      }));
    };
    const handleItemSubmit = () => {
      setLocalItems(localItems);
      handleSaveItem(localItems)
    };
    return (
      <>
        <Popup onClose={closeModal}>
          <ModalForumGroupsComponent
            Close={closeModal}
            handleItemSubmit={handleItemSubmit}
            selectedForumGroups={localItems}
            onInnerBasicFormChange={handleLocalFormChange}

          />

        </Popup>
      </>
    )
  }

  // Submit the RateCard Function
  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    mediaFiles.splice(
      mediaFiles.length - 1,
      1
    )
    const forumGroupsItemsData: any = selectedForumGroupsValues?.map((item: any) => {
      const itemData = {
        Name: item?.Name,
        Description: item?.Description,
        DisplayOrder: item?.DisplayOrder,

      }
      return itemData
    })
    const programData = {

      "Context": {

      },
      "Id": selectedCommunity?.Id || 0,
      "Name": selectedCommunity?.Name,
      "Region": selectedCommunity?.Region,
      "Description": selectedCommunity?.Description,
      "EndDateUtc": selectedCommunity?.EndDateUtc,
      "Remarks": selectedCommunity?.Remarks,
      "CommunityStatusId": selectedCommunity?.CommunityStatusId,
      "CommunityTypeId": selectedCommunity?.CommunityTypeId,
      "LogoUrl": selectedCommunity?.LogoUrl,
      "CoverImageUrl": selectedCommunity?.CoverImageUrl,
      "IsTrainingAvailable": selectedCommunity?.IsTrainingAvailable,
      "IsActive": selectedCommunity?.IsActive,
      "ForumGroups": forumGroupsItemsData,
      "MediaMappings": {
        "MediaFiles": mediaFiles,
        "Templates": []

      }
    }
    if (parmas?.id > 0) {
      await dispatch(communities.resetAction({ actionType: 'update' }))
      await dispatch(communities.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/community/communities`, entity: 'communities', jsonData: {
          Context: {},
          Records: [
            programData
          ]

        }
      })).then(() => {
        back()
      })

    } else {
      await dispatch(communities.resetAction({ actionType: 'create' }))
      await dispatch(communities.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/community/communities`, entity: 'communities', jsonData: {

          Context: {},
          Records: [
            programData
          ]

        }
      })).then(() => {
        back()
      })

    }

  }

  // MEDIA FILES
//image picker logourl
  const changeLogoImage = ( templateField: any, fileType: any, selectedCommunity: any) => {
          dispatch(settings.set({ getUploadFiles: 'open' }))
          setOpenConfirmationLogoFile(true)
          setOpenImageFile({
              currentFileSrc: selectedCommunity?.LogoUrl || templateField ,
              folder: 'community',
              type: fileType
          })
  
        
      }

      const handleLogoSubmit = (data: any) => {
        const logoData = {
          LogoUrl:data
        }
        setSelectedCommunity({...selectedCommunity, ...logoData})      
    }
//image picker logourl
//image picker coverurl
const changeCoverImage = ( templateField: any, fileType: any, selectedCommunity: any) => {
  dispatch(settings.set({ getUploadFiles: 'open' }))
  setOpenConfirmationCoverFile(true)
  setOpenImageFile({
      currentFileSrc: selectedCommunity?.CoverImageUrl || templateField ,
      folder: 'community',
      type: fileType
  })

}

const handleCoverSubmit = (data: any) => {
const logoData = {
  CoverImageUrl:data
}
setSelectedCommunity({...selectedCommunity, ...logoData})      
}

//image picker coverurl

  return (
    <>

    {getUploadFiles == 'open' && openConfirmationLogoFile &&
                    <UploadFiles currentFilesSrc={openImageFile?.currentFileSrc}
                        folder={openImageFile?.folder}
                        handleClose={handleClose}
                        handleFilesSubmit={handleLogoSubmit}
                        type={openImageFile?.type}
                        ownerId={parmas?.id}
                    />
                }

{getUploadFiles == 'open' && openConfirmationCoverFile &&
                    <UploadFiles currentFilesSrc={openImageFile?.currentFileSrc}
                        folder={openImageFile?.folder}
                        handleClose={handleClose}
                        handleFilesSubmit={handleCoverSubmit}
                        type={openImageFile?.type}
                        ownerId={parmas?.id}
                    />
                }

      {
        addItem ? <NewItemPopup handleSaveItem={handleSaveItem} /> : <></>
      }
      {isLoading ? <PageLoader /> :


        <CommunityComponent
          onInnerBasicFormChange={handleInnerbasicFormChange}
          selectedCommunity={selectedCommunity}
          back={back}
          handleFormSubmit={handleFormSubmit}
          onFormItemChange={handleFormMediaItemChange}
          id={parmas?.id}
          selectedForumGroupsValues={selectedForumGroupsValues}
          columnDefs={columnDefs}
          handleEdit={handleEdit}
          additionButtons={additionButtons}
          handleDelete={handleDelete}
          libraryData={libraryData}
          changeLogoImage={changeLogoImage}
           changeCoverImage={changeCoverImage}
        />
      }

    </>
  )

}

export default Community;